import React from 'react';
import { Container, Typography, Paper } from '@mui/material';

const Privacy = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper 
        elevation={8}
        sx={{ 
          borderRadius: 4,
          backgroundColor: '#ffffff',
          boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
          border: '1px solid rgba(0,0,0,0.1)',
          p: { xs: 4, sm: 6 }
        }}
      >
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom
          sx={{ 
            background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 50%, #e55039 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: 800,
            textAlign: 'center',
            mb: 4
          }}
        >
          Ochrana osobních údajů
        </Typography>
        
        <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.6, mb: 3 }}>
          Vaše soukromí je pro nás důležité. Zásadou aplikace Nechci Lepek je respektovat vaše soukromí ohledně jakýchkoli informací, které od vás můžeme prostřednictvím naší aplikace shromažďovat.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
          1. Informace, které shromažďujeme
        </Typography>
        <Typography paragraph sx={{ lineHeight: 1.6, mb: 3 }}>
          Neshromažďujeme žádné osobní údaje našich uživatelů. Aplikace vyžaduje přístup ke kameře vašeho zařízení výhradně za účelem skenování čárových kódů. Tento přístup ke kameře je dočasný a přímý; neukládáme ani nepřenášíme žádné obrázky nebo videa z vaší kamery. Jedinými přenášenými daty je číslo naskenovaného čárového kódu.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
          2. Jak využíváme informace
        </Typography>
        <Typography paragraph sx={{ lineHeight: 1.6, mb: 3 }}>
          Data čárových kódů zasílaná z vašeho zařízení jsou použita výhradně k dotazování veřejných databází potravin (např. Open Food Facts) pro získání a zobrazení informací o produktech. Nearchivujeme, neukládáme ani neanalyzujeme čárové kódy, které skenujete, pro žádný jiný účel.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
          3. Poskytovatelé služeb
        </Typography>
        <Typography paragraph sx={{ lineHeight: 1.6, mb: 3 }}>
          Můžeme využívat služby třetích stran za účelem získávání dat o produktech. Tyto třetí strany mají přístup k datům čárových kódů pouze za účelem plnění této úlohy naším jménem a jsou povinny tyto údaje nezveřejňovat ani nepoužívat pro žádný jiný účel.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
          4. Zabezpečení
        </Typography>
        <Typography paragraph sx={{ lineHeight: 1.6, mb: 3 }}>
          Bezpečnost vašich dat je pro nás důležitá, ale pamatujte, že žádná metoda přenosu přes internet nebo metoda elektronického úložiště není 100% bezpečná. I když se snažíme používat komerčně přijatelné prostředky k ochraně vašich dat, nemůžeme zaručit jejich absolutní bezpečnost.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
          5. Změny těchto zásad ochrany osobních údajů
        </Typography>
        <Typography paragraph sx={{ lineHeight: 1.6, mb: 3 }}>
          Naše zásady ochrany osobních údajů můžeme čas od času aktualizovat. O jakýchkoli změnách vás budeme informovat zveřejněním nových zásad ochrany osobních údajů na této stránce. Doporučujeme vám pravidelně kontrolovat tuto stránku kvůli případným změnám.
        </Typography>
        
        <Typography 
          paragraph 
          sx={{ 
            mt: 4, 
            pt: 3, 
            borderTop: '1px solid rgba(0,0,0,0.1)', 
            fontStyle: 'italic',
            color: '#666'
          }}
        >
          Naposledy aktualizováno: {new Date().toLocaleDateString('cs-CZ')}
        </Typography>
      </Paper>
    </Container>
  );
};

export default Privacy;
